<template>
  <div class="ee-upload-multi">
    <div class="ee-upload-multi__img-list">
      <template v-if="value && value.length">
        <div v-for="imgName in value" :style="style" class="ee-upload-multi__hot">
          <img :src="`http://img.easteat.com/${imgName}`" alt="">
          <i @click="handleDelete(imgName)" class="text-icon icon-close"></i>
        </div>
      </template>
      <div @click="handleOpenFile" :style="style" class="ee-upload-multi__hot">
        <i :class="`text-icon icon-${icon}`"></i>
        <input multiple @change="handleChange" ref="file" type="file">
      </div>
    </div>
    <div class="ee-upload-multi__desc">{{desc}}</div>
  </div>
</template>
<script>
  export default {
    compName: 'ee-upload-multi',
    props: {
      width: Number,
      height: Number,
      value: Array,
      name: {
        type: String,
        default: 'file'
      },
      fileType: String,
      desc: String,
      icon: {
        type: String,
        default: 'add'
      }
    },
    data () {
      return {
        style: {
          width: `${this.width}px`,
          height: `${this.height}px`
        }
      }
    },
    methods: {
      handleOpenFile () {
        this.$refs.file.click()
      },
      handleDelete (imgName) {
        const newValue = this.value.filter(n => n !== imgName)
        this.$emit('input', newValue)
      },
      handleChange () {
        const files = this.$refs.file.files
        if (files && files.length > 0) {
          if (files.length + this.value.length > 15) {
            return this.$message.warning('最多选择15张图片')
          }
          Promise.all([].map.call(files, f => {
            const data = new FormData()
            data.append(this.name, f)
            return this.$store.dispatch('UPLOAD', data)
          }))
            .then(args => {
              const newValue = [...this.value, ...args]
              this.$emit('input', newValue)
            })
            .catch((...err) => console.error(err))
        } else {
          this.$emit('input', '')
        }
      }
    }
  }
</script>
<style>
  @component-namespace gd{
    @b upload-multi {
      display: flex;
      flex-direction: column;
      margin-bottom: 30px;
      @e img-list {
        display: flex;
        justify-content: space-between;
        flex-wrap: wrap;
      }
      @e hot {
        position: relative;
        display: flex;
        justify-content: center;
        align-items: center;
        background-color: rgba(225, 225, 225, .21);
        border: 1px solid #eee;
        margin-bottom: 10px;
        input {
          display: none;
        }
        .text-icon {
          font-size: 60px;
          color: #eee;
          &.icon-close {
            position: absolute;
            color: #000;
            top: 10px;
            right: 10px;
            font-size: 12px;
          }
        }
        img {
          max-width: 100%;
          max-height: 100%;
        }
      }
      @e desc {
        padding-top: 20px;
        text-align: center;
        color: #7a8fac;
        font-size: 12px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/packages/upload/UploadMulti.vue?f2e3b16e